const DEVELOPERS = ['012.001P900000Wt4i7'];

const companyType = (cwid: string): string => {
  if (DEVELOPERS.includes(cwid)) {
    return 'Bauträger';
  }

  return 'Immobilienmakler';
};

export default companyType;
